module.exports = __webpack_public_path__ + "static/img/sleep.c1efc3cc.svg";